export const exec = () => {};
export const execFile = (_file, _args, _options, callback) => callback?.(null, { stdout: "", stderr: "" });

export const spawn = () => ({
  stdout: null,
  stderr: null,
  on() {
    return this;
  },
  kill() {},
});

export default { exec, execFile, spawn };
